module.exports = __webpack_public_path__ + "media/images/icons/sponsoring-f1355c09667865738df75269ef1fbfac.svg";